module.exports = __webpack_public_path__ + "static/media/pdp_postcardHover.189961be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/pdp-hover/pdp_postcardHover.jpg
// module id = 1033
// module chunks = 49